import { useLanguage } from "../contexts/LanguageContext";

export default function ServicesHero() {
    const { t } = useLanguage();
    return (
        <div>
            <div className="relative h-[50vh] overflow-hidden rtl:rounded-br-[1%] ltr:rounded-bl-[1%] md:mx-10 ">
                <div className="bg-[#244473]/50 absolute top-0 left-0 w-full h-full" />
                <p className="text-white md:text-6xl text-2xl font-bold absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">{t("services.hero.title")}</p>
                <p className="text-white text-center md:text-2xl text-lg w-full font-bold absolute top-3/4 left-1/2 -translate-x-1/2 -translate-y-1/2">{t("services.hero.description")}</p>
                <img src="/images/services-hero.jpg" alt="Services Hero" className="w-full h-full object-cover" />
            </div>
        </div>
    );
}